import { useContextGenerator } from '@lessonup/typescript-core/ui';
import '@lessonup/typescript-core/ui/components/spinners/RocketSpinner.less';
import classNames from 'classnames';
import React, { useState } from 'react';

const SpinnerContext = React.createContext<SpinnerContextProps | undefined>(undefined);

export interface SpinnerContextProps {
  open: (withBackground?: boolean) => void;
  close: () => void;
  isShown: boolean;
}

export const SpinnerProvider: React.FC<React.PropsWithChildren> = (props) => {
  const [isShown, setIsShown] = useState<boolean>(false);
  const [useBackground, setUseBackground] = useState(false);

  function open(withBackground?: boolean) {
    if (withBackground) {
      setUseBackground(true);
    }
    setIsShown(true);
  }

  function close() {
    setIsShown(false);
  }

  return (
    <SpinnerContext.Provider value={{ open, close, isShown }}>
      {props.children}
      {isShown ? (
        <div id="spinner" className={classNames({ 'transparent-background': !useBackground })}>
          <div id="inner-spinner" />
        </div>
      ) : null}
    </SpinnerContext.Provider>
  );
};

// eslint-disable-next-line react-hooks/rules-of-hooks -- auto-generated TECH-258
export const useSpinnerContext = useContextGenerator(SpinnerContext, 'SpinnerContext');
